<canvas #ntCnvs
        id="ntCnvs"
        (mouseout)="onMouseOut($event)"></canvas>
